import * as React from 'react';
import { SVGProps } from 'react';

const SvgProvider = (props: SVGProps<SVGSVGElement>) => (
  <svg width={78} height={53} viewBox="0 0 78 53" fill="none" role="img" {...props}>
    <g opacity={0.5}>
      <path
        fill="#ACB2C4"
        d="M0 51h78v2H0zM26 13a4 4 0 0 1 4-4h18a4 4 0 0 1 4 4v38H26V13ZM54 24h14a4 4 0 0 1 4 4v23H54V24ZM6 28a4 4 0 0 1 4-4h14v27H6V28Z"
      />
      <path
        d="M35 41a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v10h-8V41ZM58 40h4v4h-4v-4ZM58 34h4v4h-4v-4ZM58 28h4v4h-4v-4ZM64 40h4v4h-4v-4ZM64 34h4v4h-4v-4ZM64 28h4v4h-4v-4ZM43 35v-4h4v4h-4ZM37 35v-4h4v4h-4ZM31 35v-4h4v4h-4ZM43 29v-4h4v4h-4ZM43 23v-4h4v4h-4ZM37 29v-4h4v4h-4ZM37 23v-4h4v4h-4ZM31 29v-4h4v4h-4ZM31 23v-4h4v4h-4ZM10 40h4v4h-4v-4ZM10 34h4v4h-4v-4ZM10 28h4v4h-4v-4ZM16 40h4v4h-4v-4ZM16 34h4v4h-4v-4ZM16 28h4v4h-4v-4Z"
        fill="#fff"
      />
      <circle cx={39} cy={8} r={6.75} fill="#ACB2C4" stroke="#fff" strokeWidth={1.5} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.333 4h-2.666v2.666H35v2.667h2.667V12h2.666V9.333H43V6.666h-2.667V4Z"
        fill="#fff"
      />
    </g>
  </svg>
);

export default SvgProvider;
